import { useNavigate } from 'react-router-dom';
import BackArrowIcon from '../Icons/BackArrowIcon';
import Button from './Button';
interface IBackButtonProps {
  label: string;
  isEdit?: boolean;
  isDetail?: boolean;
}
const BackButton = ({ isEdit, label, isDetail = false }: IBackButtonProps) => {
  const navigate = useNavigate();
  return (
    <div className="content-head mb-5 d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center justify-content-start gap-4">
        <Button
          className="btn back-arrow "
          type="button"
          onClick={() => navigate(-1)}
        >
          <BackArrowIcon />
        </Button>
        <h1 className="mb-0">
          {!isDetail ? (isEdit ? `Update ${label}` : `Add ${label}`) : label}
        </h1>
      </div>
    </div>
  );
};
export default BackButton;
